

import { GET_AUTORESP_DATA ,GET_AUTORESP_DATA_FAILED} from '../actions/types';
import { getIntegersParsedObject } from 'h-commons';

const initialState = {
    'all': {
        content: '',
        enabled: 1
    },
    'bh':{ 
        content: '',
        enabled: 0
    },
    'nonBh':{
        content: '',
        enabled: 0
    },
    responseHourType: 1

}

const parseAutoResponderData = (autoRespData) =>{
    autoRespData = getIntegersParsedObject(autoRespData)
    let allMailData = initialState.all;
    let nonBhData = initialState.nonBh;
    let bhData =  initialState.bh;
    let exlusionListData = initialState.exclusion_list;
    let responseHourType = 1;
    let editorData ='';
    let bhEditorData='';
    let respData = {};

    if("all" in autoRespData){
        allMailData = autoRespData['all']
        responseHourType = (!allMailData.enabled)? 2 : 1
        editorData = allMailData.content;
    }else{
        allMailData.enabled = 0;
    }

    if("non-bh" in autoRespData){
        nonBhData = autoRespData['non-bh'];
        allMailData.content = nonBhData.content;
        editorData = ("all" in autoRespData)? allMailData.content:nonBhData.content;
        responseHourType = (nonBhData.enabled)? 2 : 1;
    }

    if("bh" in autoRespData){
        bhData = autoRespData['bh'];
        bhEditorData = bhData.content;
        responseHourType = (nonBhData.enabled || bhData.enabled)? 2 : 1;
    }
    if("exclusion_list" in autoRespData){
        exlusionListData = autoRespData['exclusion_list']
    }

    respData ={
        'all': allMailData,
        'nonBh':nonBhData,
        'bh': bhData,
        'exclusionList':exlusionListData,
        responseHourType,
        editorData,
        bhEditorData
    }

    return respData;
}

export const getAutoResp = (state = initialState, action) => {
    switch (action.type) {
        case GET_AUTORESP_DATA:
            const autoRespData = parseAutoResponderData(action.payload);
            return {
                ...state, ...autoRespData
            }
        case GET_AUTORESP_DATA_FAILED :
          return{
           ... action.payload
          }
        default:
            return state
    }
}
export default getAutoResp;

